<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <div class="d-flex align-items-center justify-content-end mb-3">
        <a href="javascript:void(0)" @click="$router.go(-1)">
          <CIcon name="cil-arrow-left" class="mr-2" />Voltar
        </a>
      </div>

      <CForm @submit.prevent="send">
        <!-- Fields -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{
                  $route.params.id
                    ? 'Editar Usuário restrito'
                    : 'Cadastrar Usuário restrito'
                }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <!-- Status -->
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="12">
                <CRow>
                  <!-- Name -->
                  <CCol lg="4">
                    <CInput v-model="form.name" label="Nome" :disabled="true" />
                  </CCol>

                  <!-- Email -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.email"
                      label="Email"
                      :disabled="true"
                    />
                  </CCol>

                  <!-- Profile -->
                  <CCol lg="4">
                    <div class="form-group">
                      <label for="">Perfil*</label>

                      <Multiselect
                        :value="
                          profileOptions.find(
                            (option) => option.value == form.profile
                          )
                        "
                        :options="profileOptions"
                        label="label"
                        track-by="value"
                        :disabled="processing"
                        :required="true"
                        @select="(selected) => (form.profile = selected.value)"
                      />
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <!-- Social Reason -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.social_reason"
                      label="Razão Social"
                      :disabled="true"
                    />
                  </CCol>

                  <!-- CNPJ -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.document"
                      label="CNPJ"
                      :disabled="true"
                    />
                  </CCol>

                  <!-- Internal Code -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.code"
                      label="Código Interno"
                      :disabled="processing"
                      maxlength="6"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a href="javascript:void(0)" class="mr-3" @click="resetForm"
            >Limpar alterações</a
          >
          <CButton color="success" type="submit" :disabled="processing">
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import CardLog from '@/components/ui/CardLog'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/users-restrict.service'

export default {
  metaInfo: {
    title: 'Usuários',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        !vm.$store.state.auth.permissions.includes(
          'manage_restricted_area_users'
        )
      ) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Modal,
    Multiselect,
    CardLog
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        name: '',
        email: '',
        status: true,
        profile: '',
        social_reason: '',
        document: '',
        code: ''
      },
      form: {},
      profileOptions: [
        {
          label: 'Distribuidor',
          value: '1'
        },
        {
          label: 'Representante',
          value: '2'
        }
      ],
      processing: false,
      new: true,
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            ...data,
            status: data.status && !!data.approved_at
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async approveUser() {
      const response = await Service.approve(this.$route.params.id)

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: 'Usuário aprovado com sucesso!',
          color: 'success',
          redirect: true
        }

        setTimeout(() => {
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 3000)
      }
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        code: this.form.code,
        profile: this.form.profile,
        status: this.form.status,
        id: this.$route.params.id
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Usuário atualizado com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Usuário cadastrado com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
